<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-2 text-white text-uppercase font-raleway font-weight-700">{{ detail.name }}
                                    <span>{{ detail.year }}</span>
                                </h1>
                                <p class="lead  text-white">
                                    Categoría: <b>{{ detail.population_name }}</b>
                                </p>
                                <div class="btn-wrapper">
                                    <base-button tag="a"
                                                 href="javascript:;"
                                                 class="mb-3 mb-sm-0"
                                                 type="info"
                                                 icon="fa fa-arrow-left"
                                                 style="border-radius:1.5rem">
                                        Nacional
                                    </base-button>
                                    <base-button tag="a"
                                                 href="javascript:;"
                                                 class="mb-3 mb-sm-0"
                                                 type="white"
                                                 style="border-radius:1.5rem">
                                        La Paz
                                    </base-button>
                                </div>
                            </div>
                            <div class="col-lg-6">

                                <div class="wrapper-percent text-center">
                                    <div class="counter counter-lg">
                                      <div class="counter-number-group circle">
                                        <span class="counter-number">{{ detail.calification | getNumber }}</span>
                                        <span class="counter-number-related">.{{ detail.calification | getDecimal }}%</span>
                                      </div>
                                      <div class="counter-label">{{ detail.calification_name }}</div>
                                      <div class="counter-label-text">Puesto Niv. Nacional</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>

        <section class="section section-lg">
            <div class="container">
                    <div class="row justify-content-center mt--300">
                        <div class="col-lg-12">
                            <card shadow body-classes="p-lg-5">
                                <div class="px-4">
                                    <h4 class="mb-1 font-weight-600">PRESUPUESTO</h4>
                                    <div class="row">
                                        <div class="col-md-11 offset-md-1">

                                            <div class="wrapper-barchart mt-4">
                                                <h5 class="mb-1 mt-2">A. Presupuesto de Inversión Total menos Deudas</h5>

                                                <div class="row row-gridX justify-content-between align-items-center progress-bar-color-purple">
                                                    <div class="col-lg-3">
                                                        <h3 class="h6 font-weight-bold mt-4 text-right">{{ detail.total_programmed_budget | decimal }} Bs</h3>
                                                    </div>
                                                    <div class="col-lg-9">
                                                        <base-progress :value="100" :striped="false" :animated="false" :height="20" type="primary" label="Programado" ></base-progress>
                                                    </div>
                                                </div>
                                                <div class="row row-gridX justify-content-between align-items-center progress-bar-color-purple">
                                                    <div class="col-lg-3">
                                                        <h3 class="h6 font-weight-bold mt-4 text-right">{{ detail.total_executed_budget | decimal }} Bs</h3>
                                                    </div>
                                                    <div class="col-lg-9">
                                                        <base-progress :value="executedTotalPercent" :striped="false" :animated="false" :height="20" type="primary" label="Ejecutado" ></base-progress>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="wrapper-barchart mt-5">
                                                <h5 class="mb-1 mt-2">B. Presupuesto de Inversión en IIEG</h5>

                                                <div class="row row-gridX justify-content-between align-items-center progress-bar-color-purple">
                                                    <div class="col-lg-3">
                                                        <h3 class="h6 font-weight-bold mt-4 text-right">{{ detail.iieg_programmed_budget | decimal }} Bs</h3>
                                                    </div>
                                                    <div class="col-lg-9">
                                                        <base-progress :value="100" :striped="false" :animated="false" :height="20" type="primary" label="Programado" ></base-progress>
                                                    </div>
                                                </div>
                                                <div class="row row-gridX justify-content-between align-items-center progress-bar-color-orange">
                                                    <div class="col-lg-3">
                                                        <h3 class="h6 font-weight-bold mt-4 text-right">{{ detail.iieg_executed_budget | decimal }} Bs</h3>
                                                    </div>
                                                    <div class="col-lg-9">
                                                        <base-progress :value="executedIIEGPercent" :striped="false" :animated="false" :height="20" type="primary" label="Ejecutado" ></base-progress>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="px-4 mt-5">
                                    <h4 class="mb-1 font-weight-600">COMPARACIÓN</h4>
                                    <div class="row">
                                        <div class="col-md-11 offset-md-1">

                                            <div class="wrapper-barchart mt-4">
                                                <div class="custom-chart-container" ref="chartInvYearIIEG"></div>
                                            </div>
                                            <p class="text-center">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat reprehenderit architecto error officia a? Recusandae.</p>

                                        </div>
                                    </div>
                                </div>

                            </card>
                        </div>
                    </div>
            </div>
        </section>
<!--
        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center mt--300X">
                    <div class="col-lg-12">
                        <card shadow body-classes="p-lg-5">
                            <h4 class="mb-1">PRESUPUESTO</h4>
                            <p class="mt-0">A. Presupuesto DE  EN IIEG</p>

                            <div class="custom-chart-container" ref="chartInvIIEG"></div>

                            <h4 class="mb-1">PRESUPUESTO</h4>
                            <p class="mt-0">B. PRESUPUESTO DE INVERSIÓN EN IIEG</p>

                            <div class="custom-chart-container" ref="chartInvTotal"></div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg mt--100X" style="border:1px solid #777">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-12">
                        <div class="pr-md-5">

                            <h3>PRESUPUESTO</h3>
                            <p>A. PRESUPUESTO DE INVERSIÓN EN IIEG</p>

                            <div class="custom-chart-container" ref="chart"></div>

                            <p>A. PRESUPUESTO DE INVERSIÓN EN IIEG</p>

                            <div class="chart"></div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg" style="border:1px solid #777">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-12">
                        <div class="pr-md-5">

                            <h3>PRESUPUESTO</h3>
                            <p>A. PRESUPUESTO DE INVERSIÓN EN IIEG</p>

                            <div class="chart"></div>

                            <p>A. PRESUPUESTO DE INVERSIÓN EN IIEG</p>

                            <div class="chart"></div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg section-contact-us">
            <div class="container">
                <div class="row justify-content-center mt--300X">
                    <div class="col-lg-12">
                        <card shadow body-classes="p-lg-5">
                            <h4 class="mb-1">Want to work with us?</h4>
                            <p class="mt-0">Your project is very important to us.</p>
                            Hola a todos    |
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <card shadow class="card-profile mt--300X" no-body>
                    <div class="px-4">
                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="mb-1">Want to work with us?</h4>
                                <p class="mt-0">Your project is very important to us.</p>

                            </div>
                        </div>
                        <div class="row justify-content-center">

                        </div>
                        <div class="text-center mt-5">
                            <h3>Jessica Jones
                                <span class="font-weight-light">, 27</span>
                            </h3>
                            <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>Bucharest, Romania</div>
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i>Solution Manager - Creative Tim Officer</div>
                            <div><i class="ni education_hat mr-2"></i>University of Computer Science</div>
                        </div>
                        <div class="mt-5 py-5 border-top text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-9">
                                    <p>An artist of considerable range, Ryan — the name taken by Melbourne-raised, Brooklyn-based Nick Murphy — writes, performs and records all of his own music, giving it a warm, intimate feel with a solid groove structure. An artist of considerable range.</p>
                                    <a href="#">Show more</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Download Argon</h6>
                                    <p class="description mt-3">Argon is a great free UI package based on Bootstrap 4
                                        that includes the most important components and features.</p>
                                    <div>
                                        <badge type="primary" rounded>design</badge>
                                        <badge type="primary" rounded>system</badge>
                                        <badge type="primary" rounded>creative</badge>
                                    </div>
                                    <base-button tag="a" href="#" type="primary" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-istanbul" type="success" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-success text-uppercase">Build Something</h6>
                                    <p class="description mt-3">Argon is a great free UI package based on Bootstrap
                                        4 that includes the most important components and features.</p>
                                    <div>
                                        <badge type="success" rounded>business</badge>
                                        <badge type="success" rounded>vision</badge>
                                        <badge type="success" rounded>success</badge>
                                    </div>
                                    <base-button tag="a" href="#" type="success" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-planet" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">Prepare Launch</h6>
                                    <p class="description mt-3">Argon is a great free UI package based on Bootstrap
                                        4 that includes the most important components and features.</p>
                                    <div>
                                        <badge type="warning" rounded>marketing</badge>
                                        <badge type="warning" rounded>product</badge>
                                        <badge type="warning" rounded>launch</badge>
                                    </div>
                                    <base-button tag="a" href="#" type="warning" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="img/theme/promo-1.png" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <icon name="ni ni-settings-gear-65" class="mb-5" size="lg" type="success" shadow
                                  rounded></icon>
                            <h3>Awesome features</h3>
                            <p>The kit comes with three pre-built pages to help you get started faster. You can change
                                the text and images and you're good to go.</p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-settings-gear-65"></badge>
                                        <h6 class="mb-0">Carefully crafted components</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-html5"></badge>
                                        <h6 class="mb-0">Amazing page examples</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-satisfied"></badge>
                                        <h6 class="mb-0">Super friendly support team</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section bg-secondary">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img v-lazy="'img/theme/img-1-1200x1000.jpg'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">Design System</h4>
                                <p class="lead text-italic text-white">The Arctic Ocean freezes every winter and much of
                                    the sea-ice then thaws every summer, and that process will continue whatever
                                    happens.</p>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <icon name="ni ni-settings" class="mb-5" size="lg" type="warning" shadow rounded></icon>

                            <h3>Our customers</h3>
                            <p class="lead">Don't let your uses guess by attaching tooltips and popoves to any element.
                                Just make sure you enable them first via JavaScript.</p>
                            <p>The kit comes with three pre-built pages to help you get started faster. You can change
                                the text and images and you're good to go.</p>
                            <p>The kit comes with three pre-built pages to help you get started faster. You can change
                                the text and images and you're good to go.</p>
                            <a href="#" class="font-weight-bold text-warning mt-5">A beautiful UI Kit for impactful
                                websites</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-warning shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="img/ill/ill-2.svg" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div>
                                <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow
                                      rounded></icon>
                            </div>
                            <div class="pl-4">
                                <h4 class="display-3 text-white">Modern Interface</h4>
                                <p class="text-white">The Arctic Ocean freezes every winter and much of the sea-ice then
                                    thaws every summer, and that process will continue whatever happens.</p>
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-satisfied" gradient="success" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-success">Awesome Support</h5>
                                    <p>The Arctic Ocean freezes every winter and much of the sea-ice then thaws
                                        every summer, and that process will continue whatever happens.</p>
                                    <a href="#" class="text-success">Learn more</a>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-active-40" gradient="warning" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-warning">Modular Components</h5>
                                    <p>The Arctic Ocean freezes every winter and much of the sea-ice then thaws
                                        every summer, and that process will continue whatever happens.</p>
                                    <a href="#" class="text-warning">Learn more</a>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">The amazing Team</h2>
                        <p class="lead text-muted">According to the National Oceanic and Atmospheric Administration,
                            Ted, Scambos, NSIDClead scentist, puts the potentially record maximum.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/team-1-800x800.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Ryan Tompson</span>
                                    <small class="h6 text-muted">Web Developer</small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="#" type="warning" icon="fa fa-twitter" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="warning" icon="fa fa-facebook" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="warning" icon="fa fa-dribbble" rounded
                                                 icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/team-2-800x800.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Romina Hadid</span>
                                    <small class="h6 text-muted">Marketing Strategist</small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="#" type="primary" icon="fa fa-twitter" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="primary" icon="fa fa-facebook" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="primary" icon="fa fa-dribbble" rounded
                                                 icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/team-3-800x800.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Alexander Smith</span>
                                    <small class="h6 text-muted">UI/UX Designer</small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="#" type="info" icon="fa fa-twitter" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="info" icon="fa fa-facebook" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="info" icon="fa fa-dribbble" rounded
                                                 icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/team-4-800x800.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">John Doe</span>
                                    <small class="h6 text-muted">Founder and CEO</small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="#" type="success" icon="fa fa-twitter" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="success" icon="fa fa-facebook" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="success" icon="fa fa-dribbble" rounded
                                                 icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg pt-0">
            <div class="container">
                <card gradient="warning"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">We made website building easier for you.</h3>
                                <p class="lead text-white mt-3">I will be the leader of a company that ends up being
                                    worth billions of dollars, because I got the answers. I understand culture.</p>
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <base-button tag="a" href="https://www.creative-tim.com/product/vue-argon-design-system"
                                             type="white" block size="lg">
                                    Download Vue
                                </base-button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Build something</h2>
                        <p class="lead text-white">According to the National Oceanic and Atmospheric Administration,
                            Ted, Scambos, NSIDClead scentist, puts the potentially record low maximum sea ice extent
                            tihs year down to low ice.</p>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <icon name="ni ni-settings" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Building tools</h5>
                        <p class="text-white mt-3">Some quick example text to build on the card title and make up the
                            bulk of the card's content.</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-ruler-pencil" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Grow your market</h5>
                        <p class="text-white mt-3">Some quick example text to build on the card title and make up the
                            bulk of the card's content.</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-atom" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Launch time</h5>
                        <p class="text-white mt-3">Some quick example text to build on the card title and make up the
                            bulk of the card's content.</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg pt-lg-0 section-contact-us">
            <div class="container">
                <div class="row justify-content-center mt--300">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">Want to work with us?</h4>
                            <p class="mt-0">Your project is very important to us.</p>
                            <base-input class="mt-5"
                                        alternative
                                        placeholder="Your name"
                                        addon-left-icon="ni ni-user-run">
                            </base-input>
                            <base-input alternative
                                        placeholder="Email address"
                                        addon-left-icon="ni ni-email-83">
                            </base-input>
                            <base-input class="mb-4">
                                    <textarea class="form-control form-control-alternative" name="name" rows="4"
                                              cols="80" placeholder="Type a message..."></textarea>
                            </base-input>
                            <base-button type="default" round block size="lg">
                                Send Message
                            </base-button>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-8 text-center">
                        <h2 class="display-3">Do you love this awesome
                            <span class="text-success">Design System for Bootstrap 4?</span>
                        </h2>
                        <p class="lead">Cause if you do, it can be yours for FREE. Hit the button below to navigate to
                            Creative Tim where you can find the Design System in HTML. Start a new project or give an
                            old Bootstrap project a new look!</p>
                        <div class="btn-wrapper">
                            <a href="https://www.creative-tim.com/product/vue-argon-design-system"
                               class="btn btn-primary mb-3 mb-sm-0">Download Vue</a>
                        </div>
                        <div class="text-center">
                            <h4 class="display-4 mb-5 mt-5">Available on these technologies</h4>
                            <div class="row justify-content-center">
                                <div class="col-lg-2 col-4">
                                    <a href="https://getbootstrap.com/" target="_blank" data-toggle="tooltip"
                                       data-original-title="Bootstrap 4 - Most popular front-end component library">
                                        <img v-lazy="'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/bootstrap.jpg'"
                                             class="img-fluid">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="https://www.sketchapp.com/" target="_blank" data-toggle="tooltip"
                                       data-original-title="[Coming Soon] Sketch - Digital design toolkit">
                                        <img v-lazy="'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/sketch.jpg'"
                                             class="img-fluid opacity-5">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="https://www.adobe.com/products/photoshop.html" data-toggle="tooltip"
                                       data-original-title="[Coming Soon] Adobe Photoshop - Software for digital images manipulation">
                                        <img v-lazy="'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/ps.jpg'"
                                             class="img-fluid  opacity-5">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="https://vuejs.org/" target="_blank" data-toggle="tooltip"
                                       data-original-title="Vue.js - The progressive javascript framework">
                                        <img v-lazy="'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/vue.jpg'"
                                             class="img-fluid">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="https://angularjs.org/" target="_blank" data-toggle="tooltip"
                                       data-original-title="[Coming Soon] Angular - One framework. Mobile &amp; desktop">
                                        <img v-lazy="'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/angular.jpg'"
                                             class="img-fluid opacity-5">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="https://reactjs.org/" target="_blank" data-toggle="tooltip"
                                       data-original-title="[Coming Soon] React - A JavaScript library for building user interfaces">
                                        <img v-lazy="'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/react.jpg'"
                                             class="img-fluid opacity-5">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
-->
    </div>
</template>

<script>
const axios = require('axios');
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  name: "region",
  data() {
    return {
        chart: '',
        detail: ''
    }
  },
  components: {

  },
  filters: {
    getNumber(n){
        return ((""+n).split('.'))[0];
    },
    getDecimal(n){
        return ((""+n).split('.'))[1];
    },
    decimal(num) {
        var nStr = parseFloat(num).toFixed(2);
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;

        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    }
  },
  computed: {
    executedTotalPercent(){
        let percent = (this.detail.total_executed_budget * 100)/this.detail.total_programmed_budget;
        return parseInt(percent);
    },
    executedIIEGPercent(){
        let percent = (this.detail.iieg_executed_budget * 100)/this.detail.iieg_programmed_budget;
        return parseInt(percent);
    }
  },
  methods: {

    getData(){
        let uri = 'http://gregorias-equidad.test/apiv1/investments/2016/region/1202';
        axios.get(uri).then((response) => {
            this.chart =response.data.result.chart;
            this.detail =response.data.result.detail;
            console.log(response.data.result);
            this.chartInvestmentsByYearIIEG();
        }).catch((response) => { console.log(response) });
    },
    chartInvestmentsByYearIIEG(){
        let chart = am4core.create(this.$refs.chartInvYearIIEG, am4charts.XYChart);
        chart.paddingTop = 50;
        let data = this.chart;
        chart.data = data;

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.disabled = true;
        categoryAxis.renderer.minGridDistance = 30;
        //categoryAxis.renderer.inside = true;
        //categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
        categoryAxis.renderer.labels.template.fontSize = 20;


        var  valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.grid.template.strokeDasharray = "4,4";
        valueAxis.renderer.labels.template.disabled = true;
        valueAxis.min = 0;


        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "investment";
        series.dataFields.categoryX = "year";
        series.name = "Porcentaje";
        series.clustered = false;
        //series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
        series.columns.template.fillOpacity = .5;

        var columnTemplate = series.columns.template;
        columnTemplate.width = 100;
        columnTemplate.column.cornerRadiusTopLeft = 0;
        columnTemplate.column.cornerRadiusTopRight = 0;
        columnTemplate.adapter.add("fill", function (fill, target) {
            return am4core.color("#cc8b00");
        });
        columnTemplate.strokeOpacity = 0;
        //columnTemplate.propertyFields.fill = am4core.color("#a8b3b7");
        //columnTemplate.propertyFields.stroke = "color";

        /*var male = chart.series.push(new am4charts.ColumnSeries());
        male.dataFields.valueX = "year";
        male.dataFields.categoryY = "investment";
        male.clustered = false;*/

        var txtLabel = series.bullets.push(new am4charts.LabelBullet());
        txtLabel.label.text = "{valueY} %";

        //txtLabel.locationY = 0.5;
        txtLabel.label.fill = am4core.color("#ffffff");

        txtLabel.label.hideOversized = false;
        txtLabel.label.truncate = false;
        txtLabel.label.horizontalCenter = "middle";
        txtLabel.label.verticalCenter = "top";

        this.chart3 = chart;
    },
    chartInvestmentsIIEG(){
        let chart = am4core.create(this.$refs.chartInvIIEG, am4charts.XYChart);
        chart.paddingRight = 20;
        let data = [{
              "country": "USA",
              "visits": 2025
            }, {
              "country": "China",
              "visits": 1882
            }, {
              "country": "Japan",
              "visits": 1809
            }, {
              "country": "Germany",
              "visits": 1322
            }, {
              "country": "UK",
              "visits": 1122
            }, {
              "country": "France",
              "visits": 1114
            }, {
              "country": "India",
              "visits": 984
            }, {
              "country": "Spain",
              "visits": 711
            }, {
              "country": "Netherlands",
              "visits": 665
            }, {
              "country": "Russia",
              "visits": 580
            }, {
              "country": "South Korea",
              "visits": 443
            }, {
              "country": "Canada",
              "visits": 441
            }, {
              "country": "Brazil",
              "visits": 395
        }];

        chart.data = data;

        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "country";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;

        categoryAxis.renderer.labels.template.adapter.add("dy", function(dy, target) {
          if (target.dataItem && target.dataItem.index & 2 == 2) {
            return dy + 25;
          }
          return dy;
        });

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "visits";
        series.dataFields.categoryX = "country";
        series.name = "Visits";
        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
        series.columns.template.fillOpacity = .8;

        var columnTemplate = series.columns.template;
        columnTemplate.strokeWidth = 2;
        columnTemplate.strokeOpacity = 1;

        this.chart2 = chart;
    },
    chartInvestmentsTotal(){
        let chart = am4core.create(this.$refs.chartInvTotal, am4charts.XYChart);
        let data = [
            {
              "year": 2015,
              "income": 23.5,
              //"color": chart.colors.next()
            }, {
              "year": 2016,
              "income": 66.2,
              //"color": chart.colors.next()
            }
        ];
        chart.data = data;

        // Create axes
        var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.numberFormatter.numberFormat = "#";
        categoryAxis.renderer.inversed = true;

        var  valueAxis = chart.xAxes.push(new am4charts.ValueAxis());

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueX = "income";
        series.dataFields.categoryY = "year";
        series.name = "Income";

        series.columns.template.fillOpacity = .8;

        series.columns.template.propertyFields.fill = "color";
        series.columns.template.tooltipText = "{valueX}";
        //series.columns.template.column3D.stroke = am4core.color("#fff");
        //series.columns.template.column3D.strokeOpacity = 0.2;

        var columnTemplate = series.columns.template;
        columnTemplate.strokeWidth = 0;
        columnTemplate.strokeOpacity = 1;
        columnTemplate.height = 30;
        columnTemplate.column.cornerRadiusTopRight = 20;
        columnTemplate.column.cornerRadiusBottomRight = 20;
        columnTemplate.strokeOpacity = 0;
    },
    exampleChart(){
        let chart = am4core.create(this.$refs.chart, am4charts.XYChart);

        chart.paddingRight = 20;

        let data = [];
        let visits = 10;
        for (let i = 1; i < 366; i++) {
          visits += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
          data.push({ date: new Date(2018, 0, i), name: "name" + i, value: visits });
        }

        chart.data = data;

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.renderer.minWidth = 35;

        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.dateX = "date";
        series.dataFields.valueY = "value";

        series.tooltipText = "{valueY.value}";
        chart.cursor = new am4charts.XYCursor();

        let scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        chart.scrollbarX = scrollbarX;

        this.chart = chart;
    }
  },
  mounted() {
    this.getData();
    //this.chartInvestmentsByYearIIEG();
    //this.chartInvestmentsIIEG();
    //this.chartInvestmentsTotal();
    //this.exampleChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
    if (this.chart2) {
      this.chart2.dispose();
    }
    if (this.chart3) {
      this.chart3.dispose();
    }
  }
};
</script>

<style scoped>
.custom-chart-container {
  width: 100%;
  height: 400px;
}
</style>